import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql, Link } from "gatsby";
import "./footer.scss";
import logo from "../images/logo.svg";
import parse from "html-react-parser";
import { returnLanguageCode } from "../helpers/language";

const Footer = ({ language }) => (
  <StaticQuery
    query={graphql`
      {
        allKenticoCloudItemFooter {
          edges {
            node {
              elements {
                footer_columns__column_1_content {
                  value
                }
                footer_columns__column_2_content {
                  value
                }
                footer_columns__column_3_content {
                  value
                }
                footer_columns__column_4_content {
                  value
                }
                language {
                  value {
                    codename
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const footer = data.allKenticoCloudItemFooter.edges.filter(({ node }) => {
        return (
          language ===
          returnLanguageCode(node.elements.language.value[0].codename)
        );
      });
      return (
        <footer className="footer">
          <img src={logo} alt="Logo" className="footer__logo" />
          <div className="footer__grid">
            <div className="footer__grid-item">
              {footer.length
                ? parse(
                    footer[0].node.elements.footer_columns__column_1_content
                      .value
                  )
                : ""}
            </div>
            <div className="footer__grid-item">
              {footer.length
                ? parse(
                    footer[0].node.elements.footer_columns__column_2_content
                      .value
                  )
                : ""}
            </div>
            <div className="footer__grid-item">
              {footer.length
                ? parse(
                    footer[0].node.elements.footer_columns__column_3_content
                      .value
                  )
                : ""}
            </div>
            <div className="footer__grid-item">
              {footer.length
                ? parse(
                    footer[0].node.elements.footer_columns__column_4_content
                      .value
                  )
                : ""}
            </div>
          </div>
        </footer>
      );
    }}
  ></StaticQuery>
);

Footer.propTypes = {
  language: PropTypes.string,
};

export default Footer;
